<template>
    <div id="location-modal" class="modal fade" role="dialog"  data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-sm">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">{{trans('step1.choose_your_location','Choose Your Location')}}</h4>
                </div>
                <div class="modal-body">
                    <form method="POST" @submit.prevent="saveLocationData">
                        <div class="row" v-if="fromDetailBar">
                            <div class="alert alert-danger">
                                <p>If you want to change Location, You will have to start over.</p>
                            </div>
                        </div>
                        <div class="row model_row">
                            <div class="col-sm-12">
                                <div class="form-group select_box_dropdown">
                                    <div class="list-group">
                                        <a href="Javascript:void(0)"
                                           class="list-group-item"
                                           :class="[resort.id === form.resort_id ? 'active' : '']"
                                           @click="changeResort(resort.id)"
                                           v-for="resort in resorts"
                                           :key="resort.id">
                                            {{ resort.name }}
                                        </a>
                                    </div>
                                    <p v-if="!form.resort_id && form_submitted" class="text-danger">{{trans('step1.','Please Select Your Location.')}}</p>
                                </div>

                            </div>
                        </div>
                        <div class="row check_box_model" v-if="resort_id && stores.length > 0">
                            <div class="col-xs-6"  v-if="getResortCode !== 'OSP'">
                                <div class="form-group">
                                    <input id="del-option" v-model="is_pickup" type="radio" class="radio radio-inline" name="is_pickup" value="0">
                                    <label for="del-option">{{ trans('general.delivery','Delivery') }}</label>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <input id="pick-option" v-model="is_pickup" type="radio" class="radio radio-inline" name="is_pickup" value="1">
                                    <label for="pick-option" v-if="getResortCode !== 'OSP'">{{ trans('general.pickup','Pickup') }}</label>
                                    <label for="pick-option" v-else>Private Ski Valet</label>
                                </div>
                            </div>
                        </div>
                        <div class="row model_row" v-if="is_pickup == 1">
                            <div class="col-sm-12">
                                <div class="form-group select_box_dropdown">
                                    <select v-model="store_id" name="store_id" id="store_id"
                                            class="form-control select_box_input"
                                            data-style="btn-primary" required="required" @change="focusNextButton">
                                        <option :value="null" disabled>{{trans('step1.store_location','Store Location')}}</option>
                                        <option :value="store.id" v-for="store in stores" :key="store.id">
                                            {{ store.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-20 text-center">
                            <button type="submit" id="location-modal-next-button" class="btn btn-blue btn-cart-md" v-if="!fromDetailBar">Next</button>
                            <button @click="startOver" data-dismiss="modal" class="btn btn-blue btn-cart-md" v-else>Start Over</button>
                        </div>
                    </form>
                    <div class="overlay-loader" v-if="isLoading">
                        <i class="overlay-img-load"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapState} from "vuex";
export default {
    name: 'LocationModal',
    props: {'fromDetailBar': false},
    computed:{
        resort_id(){
            return this.$store.state.form.resort_id;
        },
        is_pickup: {
            get(){
                return this.form.is_pickup;
            },
            set(value){
                this.form.is_pickup = value == 1 ? 1 : 0;
                this.form.store_id = null;
                this.form.delivery_date = null;
                this.form.delivery_time = null;
                this.form.return_date = null;
            }
        },
        store_id: {
            get(){
                return this.form.store_id;
            },
            set(value){
                this.form.store_id = value;
                this.form.delivery_date = null;
                this.form.delivery_time = null;
                this.form.return_date = null;
            }
        },
        ...mapState(['form', 'resorts', 'stores', 'isLoading']),
        ...mapGetters(['getResortCode']),
    },

    data(){
        return{
            form_submitted: false
        }
    },
    methods: {
        trans(key, defaultValue, msg = null) {
            let translation = '';
            if (msg) {
                translation = this.$t(key, {message: msg});
            } else {
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        saveLocationData() {
            this.form_submitted = true;
            if(this.form.resort_id){
                this.$store.dispatch('fillPortalData');
                $('.close').click();
                $('#location-modal').on('hidden.bs.modal', function (e) {
                    $('#delivery-date-modal').modal('toggle');
                });
            }
            this.$forceUpdate();
        },
        changeResort(value){
            this.$store.dispatch('setResortID', {'resort_id':value});
            this.focusNextButton();
        },
        startOver(){
            this.$router.push(this.$store.getters.getStep1Route);
        },

        focusNextButton(){
            let buttonEle = document.getElementById('location-modal-next-button');
            if(buttonEle){
                this.cursorFocus(buttonEle, 'start')
            }
        },
        cursorFocus(elem, block='end') {
            elem.focus();
            elem.scrollIntoView({behavior: "smooth", block: block});
        },
    }
}
</script>
<style scoped>
.list-group {
    overflow:scroll;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden; /* Hide horizontal scrollbar */
    max-height: 265px !important;
}
</style>
